import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Cpu, CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Mechanism() {
  return <SectionWrapper className="bg-brand-dark relative" data-id="element-107">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-108">
        <div className="relative rounded-3xl p-1 bg-gradient-to-b from-brand-green to-brand-green/10 box-glow" data-id="element-109">
          <div className="bg-brand-card rounded-[23px] p-8 md:p-12 h-full" data-id="element-110">
            <div className="flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-8 mx-auto" data-id="element-111">
              <Cpu className="w-8 h-8 text-brand-green" data-id="element-112" />
            </div>

            <div className="text-center mb-10" data-id="element-113">
              <h2 className="text-3xl md:text-5xl font-display uppercase mb-6" data-id="element-114">
                Presentamos el <br data-id="element-115" />
                <span className="text-brand-green text-glow" data-id="element-116">
                  "Algoritmo de Disputa 2026"
                </span>
              </h2>
              <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-117">
                Es un método diseñado para hablar el mismo idioma que el
                software de los burós.
              </p>
            </div>

            <div className="space-y-6 text-lg text-gray-300 mb-12" data-id="element-118">
              <div className="flex items-start gap-4" data-id="element-119">
                <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-1" data-id="element-120" />
                <p data-id="element-121">
                  En lugar de pedir "por favor", utilizamos{' '}
                  <strong className="text-white" data-id="element-122">
                    discrepancias técnicas de datos
                  </strong>{' '}
                  para forzar la eliminación legal de cuentas negativas.
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-123">
                <CheckCircle2 className="w-6 h-6 text-brand-green shrink-0 mt-1" data-id="element-124" />
                <p data-id="element-125">
                  Si el buró no puede probar la exactitud total en 30 días,{' '}
                  <strong className="text-white" data-id="element-126">
                    la ley los obliga a borrar la deuda.
                  </strong>{' '}
                  Punto.
                </p>
              </div>
            </div>

            <div className="flex justify-center" data-id="element-127">
              <CTAButton data-id="element-128" />
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}